import { createContext, useContext } from 'react';

/**
 * Lets any org-chart node card open a contact in the quick side-panel without prop-drilling a
 * callback through the recursive tree. Backed by LOCAL state in CompanyOrgChart (not the URL
 * record-panel singleton) so the peek can layer over the chart — and even over a company overlay
 * that itself hosts the chart — without evicting anything.
 */
export const OrgChartPreviewContext = createContext<(contactId: string) => void>(() => {});

export const useOrgChartPreview = () => useContext(OrgChartPreviewContext);
